module.exports = __webpack_public_path__ + "images/8c7fb7dff7433f2cebf051a9f8a8731f.png";